
import React from 'react'
import { SocialAccountCreator } from 'types/social-account'
import userImgPlaceholder from "assets/images/users/user-dummy-img.jpg"
import InstagramLogoIcon from 'assets/icons/InstagramLogoIcon'
import FollowersIcon from 'assets/icons/mono/FollowersIcon'
import { formatNumber } from 'utils/helpers'

const CreatorCard: React.FC<{ creator: SocialAccountCreator, showOverlay?: boolean, onHoverActions?: React.ReactNode, alwaysVisibleActions?: React.ReactNode }> = ({ creator, showOverlay = true, onHoverActions, alwaysVisibleActions }) => {

    return (
        <div className='creator-card h-100'>
            <div className="creator-card__profile_picture position-relative">
                <img src={creator?.social_account?.profile_picture_url ?? userImgPlaceholder} alt={creator.social_account.handle} />
                {
                    showOverlay &&
                    <div className="masonry-overlay flex-column justify-content-between align-items-start p-2">
                        {
                            !!onHoverActions &&
                            <div className="position-absolute" style={{ right: '8px', top: '8px', left: 'none' }} onClick={(e) => e.stopPropagation()}>
                                {onHoverActions}
                            </div>
                        }
                    </div>
                }
                {
                    !!alwaysVisibleActions &&
                    <div className="position-absolute" style={{ right: '8px', top: '8px', left: 'none' }} onClick={(e) => e.stopPropagation()}>
                        {alwaysVisibleActions}
                    </div>
                }
            </div>
            <div className="creator-card__details">
                <div className="d-flex align-items-center justify-content-between gap-2">
                    <div className="d-flex flex-column">
                        <span className="creator-card__name">
                            {creator.social_account.name}
                        </span>
                        <span className="creator-card__handle">
                            <InstagramLogoIcon />{creator.social_account.handle}
                        </span>
                    </div>
                    <div className="d-flex flex-column">
                        <span className="creator-card__followers_count">
                            <FollowersIcon /> <span>{formatNumber(creator.social_account.followers_count)}</span>
                        </span>
                        <span className="creator-card__folowers_label">
                            Followers
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreatorCard